export default __webpack_public_path__ + "static/media/product32.f110bbca.png";